











import VueOptions from '@utils/VueOptions'
import IndicatorResourceList from '@superComponents/Indicator/IndicatorResourceList'

settings =
  name: 'IndicatorList'

  resources:
    indicators:
      resourceName: 'availability_indicator'
      slug: 'availability_indicators'
      infinityScroll: true

  vue:
    components: {
      IndicatorResourceList,
    }

    computed:
      actionsForIndicators: ->
        trust: @trust
        untrust: @untrust
        fetchResource: @fetchResource

    mounted: ->
      @$refs.indicatorResourceList.refreshInfinityScroll()

    methods:
      fetchResource: (state, resourceKey, data = {}, options = {}) ->
        @fetchInfinity state, resourceKey, data, options

      trust: (indicator) ->
        payload = { indicator_id: indicator.id, trust_expires_at: null }
        @triggerResource 'indicators', 'trust', payload

      untrust: (indicator) ->
        payload = { indicator_id: indicator.id }
        @triggerResource 'indicators', 'untrust', payload

export default VueOptions.vue settings
